var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconApiEndpoints01 = function SvgIconApiEndpoints01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_api_endpoints-01_svg2__a",
    x1: -10.53,
    x2: 96.05,
    y1: 91.91,
    y2: 18.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_api_endpoints-01_svg2__a",
    id: "icon_api_endpoints-01_svg2__b",
    x1: -10.53,
    x2: 96.05,
    y1: 91.91,
    y2: 18.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_api_endpoints-01_svg2__a",
    id: "icon_api_endpoints-01_svg2__c",
    x1: -10.53,
    x2: 96.05,
    y1: 91.91,
    y2: 18.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_api_endpoints-01_svg2__a",
    id: "icon_api_endpoints-01_svg2__d",
    x1: -13.07,
    x2: 93.51,
    y1: 88.24,
    y2: 14.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_api_endpoints-01_svg2__a",
    id: "icon_api_endpoints-01_svg2__e",
    x1: -5.97,
    x2: 100.61,
    y1: 98.5,
    y2: 24.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_api_endpoints-01_svg2__a",
    id: "icon_api_endpoints-01_svg2__f",
    x1: -22.26,
    x2: 84.32,
    y1: 74.96,
    y2: 1.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_api_endpoints-01_svg2__a",
    id: "icon_api_endpoints-01_svg2__g",
    x1: -11.68,
    x2: 94.9,
    y1: 90.26,
    y2: 16.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_api_endpoints-01_svg2__a",
    id: "icon_api_endpoints-01_svg2__h",
    x1: -0.65,
    x2: 105.93,
    y1: 106.18,
    y2: 32.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_api_endpoints-01_svg2__a",
    id: "icon_api_endpoints-01_svg2__i",
    x1: -10.77,
    x2: 95.81,
    y1: 91.56,
    y2: 17.78
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m96.31 60.58-3.45-1.99c.58-2.88.87-5.77.87-8.59s-.29-5.75-.86-8.6l3.43-1.98c1.06-.61 1.82-1.61 2.14-2.79s.15-2.43-.46-3.49l-9.39-16.27a4.59 4.59 0 0 0-2.79-2.14 4.58 4.58 0 0 0-3.49.46l-3.44 1.98a44 44 0 0 0-14.89-8.62V4.6a4.6 4.6 0 0 0-4.6-4.6H40.59a4.6 4.6 0 0 0-4.6 4.6v3.95c-5.41 1.83-10.51 4.79-14.87 8.63l-3.46-2c-1.06-.61-2.3-.78-3.49-.46a4.56 4.56 0 0 0-2.79 2.14L2 33.13c-.61 1.06-.78 2.3-.46 3.49s1.08 2.18 2.14 2.79l3.45 1.99c-.58 2.88-.87 5.77-.87 8.59s.29 5.75.86 8.6l-3.43 1.98a4.597 4.597 0 0 0-1.68 6.28l9.39 16.27a4.597 4.597 0 0 0 6.28 1.68l3.44-1.98c4.34 3.82 9.45 6.78 14.89 8.62v3.95a4.6 4.6 0 0 0 4.6 4.6H59.4a4.6 4.6 0 0 0 4.6-4.6v-3.95c5.41-1.83 10.51-4.79 14.87-8.63l3.46 2c2.2 1.27 5.01.51 6.28-1.68L98 66.86c1.27-2.2.51-5.01-1.68-6.28Zm-.85 4.82-9.39 16.27c-.46.79-1.48 1.07-2.27.61l-4.38-2.53c-.56-.32-1.26-.24-1.73.19-4.48 4.14-9.87 7.27-15.59 9.04-.61.19-1.03.76-1.03 1.4v5.02c0 .92-.75 1.66-1.66 1.66H40.62c-.92 0-1.66-.75-1.66-1.66v-5.02c0-.64-.42-1.21-1.03-1.4-5.75-1.78-11.15-4.9-15.61-9.03-.28-.26-.64-.39-1-.39-.25 0-.5.06-.73.2l-4.36 2.52c-.79.46-1.81.19-2.27-.61L4.57 65.4c-.46-.79-.19-1.81.61-2.27l4.36-2.52c.56-.32.84-.97.7-1.59-.67-2.98-1.01-6.01-1.01-9.01s.35-5.99 1.03-9.01c.14-.63-.14-1.27-.7-1.59l-4.37-2.53c-.38-.22-.66-.58-.77-1.01s-.06-.88.17-1.26l9.39-16.27c.22-.38.58-.66 1.01-.77.43-.12.88-.06 1.26.17l4.38 2.53c.56.32 1.26.24 1.73-.19 4.48-4.14 9.87-7.27 15.59-9.04a1.47 1.47 0 0 0 1.03-1.4V4.62c0-.92.75-1.66 1.66-1.66h18.79c.92 0 1.66.75 1.66 1.66v5.02c0 .64.42 1.21 1.03 1.4 5.75 1.78 11.15 4.9 15.61 9.03.47.44 1.17.52 1.73.19l4.36-2.52c.38-.22.83-.28 1.26-.17.43.12.79.39 1.01.77l9.39 16.27c.22.38.28.83.17 1.26s-.39.79-.77 1.01l-4.36 2.52c-.56.32-.84.97-.7 1.59.67 2.98 1.01 6.01 1.01 9.01s-.35 5.99-1.03 9.01c-.14.63.14 1.27.7 1.59l4.37 2.53c.79.46 1.07 1.48.61 2.27Z",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 20.35c-16.35 0-29.65 13.3-29.65 29.65S33.65 79.65 50 79.65 79.65 66.35 79.65 50 66.35 20.35 50 20.35m0 56.36c-14.73 0-26.71-11.98-26.71-26.71S35.27 23.29 50 23.29 76.71 35.27 76.71 50 64.73 76.71 50 76.71",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.48 42.27H50c-.81 0-1.47.66-1.47 1.47v12.52c0 .81.66 1.47 1.47 1.47s1.47-.66 1.47-1.47v-3.23h4.01c2.97 0 5.38-2.41 5.38-5.38s-2.41-5.38-5.38-5.38m0 7.83h-4.01v-4.89h4.01c1.35 0 2.45 1.1 2.45 2.45s-1.1 2.45-2.45 2.45Z",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.98 43.22c-.21-.57-.76-.95-1.37-.95h-1.57c-.61 0-1.16.38-1.37.95l-4.7 12.52c-.28.76.1 1.6.86 1.89.76.28 1.6-.1 1.89-.86l.82-2.18h6.58l.82 2.18c.22.59.78.95 1.37.95.17 0 .35-.03.52-.09a1.47 1.47 0 0 0 .86-1.89l-4.7-12.52Zm-4.34 8.44 2.19-5.83 2.19 5.83h-4.37Z",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.09 42.27c-.81 0-1.47.66-1.47 1.47v12.52c0 .81.66 1.47 1.47 1.47s1.47-.66 1.47-1.47V43.74c0-.81-.66-1.47-1.47-1.47",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 17.08c1.02.32 2.03.7 3.02 1.12q.285.12.57.12c.57 0 1.11-.34 1.35-.89.32-.75-.03-1.61-.78-1.93-1.07-.45-2.17-.86-3.28-1.22-.77-.25-1.6.18-1.84.95-.25.77.18 1.6.95 1.84Z",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.66 66.52c-.39-.71-1.28-.97-1.99-.59-.71.39-.97 1.28-.59 1.99.61 1.12 1.28 2.21 2 3.26.28.41.74.64 1.21.64.29 0 .58-.08.83-.26.67-.46.84-1.37.38-2.04-.66-.97-1.29-1.98-1.85-3.01Z",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.99 84.41c-7.86-.68-15.33-4.09-21.02-9.6-.58-.56-1.51-.55-2.08.03-.56.58-.55 1.51.03 2.08 6.17 5.98 14.28 9.68 22.81 10.41h.13c.75 0 1.39-.58 1.46-1.34a1.47 1.47 0 0 0-1.34-1.59Z",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.12 19.04c-.67-.46-1.58-.29-2.04.38s-.29 1.58.38 2.04a34.57 34.57 0 0 1 13.89 19.53c.18.65.77 1.09 1.42 1.09a1.475 1.475 0 0 0 1.42-1.85c-2.32-8.61-7.67-16.13-15.07-21.19",
    style: {
      fill: "url(#icon_api_endpoints-01_svg2__i)"
    }
  }));
};
export default SvgIconApiEndpoints01;